
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
export const lang ={
 
  CompanyInfo:"معلومات الشركة",
  Overdraft:"السحب على المكشوف",
  Please_set_materialtype_in_product_page:"يرجى الذهاب إلى صفحة المنتج لتعديل وتعيين نوع المادة لكل منتج - المنتجات النهائية - المنتجات شبه المصنعة - الملحقات.",
  deleteAccount:"تسجيل خروج",
  deleteAccountWillDeleteAllData:"سيؤدي تسجيل الخروج من حسابك إلى حذف جميع البيانات ويجعلك غير قادر على تسجيل الدخول.",
  backupDatabase:"قاعدة بيانات النسخ الاحتياطي",
  restoreDatabase:"استعادة قاعدة البيانات",
  materialtype:"نوع المادة",
  Manufacturing:"نسخة التصنيع",
  Professional:"النسخة المهنية",
  Standard:"الطبعة القياسية",
  product:"منتج منتهي",
  halfProduct:"منتجات شبه جاهزة",
  components:"مُكَمِّلات",
  Parent:"المكون الأصلي",
  Children:"الملحقات الفرعية",
  Level:"تَسَلسُل",
  Timing:"توقيت",
  PieceCount:"قطعة",
  Wages:"أجور",
  InternalProcess:"عملية داخلية",
  ExternalProcess:"عملية خارجية",
  ProceName:"اسم العملية",
  ProceIndex:"أمر التنفيذ",
  ChargeMan:"رئيسي",
  BillMethod:"طريقة الفوترة",
  ConsumTime:"ساعات العمل",
  Accessories:"مُكَمِّلات",
  Assembly:"تجمع",
  materials:"مواد",
  task:"مهمة",
  process:"عملية",
  BOM:"بوم",
  Production:"إنتاج",
  RestorePurchaseOneUse:"استعادة عملية الشراء (مستخدم واحد (يقتصر على عمليات الشراء السابقة))",
  buy_fail_try_again:"الرجاء الضغط مرة أخرى للشراء",
  Export:"يصدّر",
  Date:"تاريخ",
  BankDetail:"التفاصيل المصرفية",
  Seller:"تاجر",
  Buver:"مشتر",
  Currency:"عملة",
  CompanyName:"اسم الشركة",
  ProformaInvoice:"الفاتورة الأولية",
  Discount:"تخفيض",
  PayStatus:"حالة السداد",
  ShippingStatus:"حالة الشحن",
  FreightType:"نوع النقل",
  Shipping:"شحن",
  Payment:"قسط",
  Moneyname:"اسم العملة",
  Tax:"الضرائب",
  Freight:"رسوم الشحن",
  Insurance:"تأمين",
  Bankfee:"الرسوم المصرفية",
  Qc:"شهادة الجودة",
  Exchangerate:"سعر الصرف",
  Shippingnumber:"رقم الشحنة",
  ShipDate:"تاريخ الشحن",
  Arrivedate:"تاريخ الوصول",
  Grossweight:"الوزن الإجمالي",
  CubicWeight:"الوزن المكعب",
  Totalpackages:"العدد الإجمالي للحزم",
  Moneytype:"نوع العملة",
  Quotedate:"تاريخ الاقتباس",
  Validitydate:"تاريخ صالح",
  Paymentterm:"انتهاء الأجر",
  Priceterm:"مصطلح التسعير",
  DeliveryTerm:"موعد التسليم",
  BankName:"اسم البنك",
  BankAddress:"عنوان البنك",
  SwiftCode:"رمز بنكي",
  Review:"مراجعة",
  Signfor:"التوقيع على الاستلام",
  Finance:"تمويل",
  Receiver:"المتلقي",
  Business:"عمل",
  ContactPerson:"الشخص الذي يمكن الاتصال به",
  Profit:"ربح",
  Staff_must_use_in_browser_please_check_the_address_in_help_page:"يجب على الموظفين استخدام Google Chrome. يرجى التحقق من عنوان IP في صفحة المساعدة لتطبيق كمبيوتر الخدمة الرئيسي، ثم أدخل العنوان في عمود URL لمتصفحات الكمبيوتر الأخرى لفتح تسجيل الدخول",
  newPassword:"كلمة المرور الجديدة",
  ForgetPassword:"ننسى كلمة المرور",
  ContactUs:"اتصل بنا/قدم اقتراحات",
  Actualpay_should_big_then_shouldpay:"لا يمكن أن تكون الإيصالات الفعلية أكبر من المستحقات",
  ShopAddress:"عنوان متجري قم بمسح رمز الاستجابة السريعة لتقديم طلب",
  Submit:"يُقدِّم",
  All:"الجميع",
  OrdernumExists:"رقم الطلب موجود بالفعل",
  PermissionDenied:"تم رفض الإذن",
  StockTransfer:"تحويل المخزن",
  FromWarehouse:"نقل خارج المستودع",
  ToWarehouse:"نقل إلى المستودع",
  PleaseUseInWebBrowser:"الرجاء استخدام وظيفة التصدير Excel في Google Chrome",
  PleasePrintInWebBrowser:"الرجاء استخدام وظيفة الطباعة في Google Chrome",
  HistoryPrice:"السعر التاريخي",
  SerialNumber:"رقم سري",
  Please_Use_In_APP:"يرجى استخدامه ضمن برامج الكمبيوتر",
  Please_Purchase_In_APP:"يرجى الشراء داخل التطبيق، وليس داخل المتصفح",
  Connect_Postgresql_database_Default_database_is_sqlite_in_local:"يمكنك الاتصال بقاعدة بيانات Postgresql. سيتم تخزين بياناتك في قاعدة بيانات Postgresql. افتراضيًا، لا تحتاج إلى الاتصال بقاعدة بيانات Postgresql. الافتراضي هو قاعدة بيانات Sqlite المحلية.",
  Connect_Postgresql_database_data_will_store_in_Postgresql:"اتصل بقاعدة بيانات Postgresql، وسيتم تخزين بياناتك في قاعدة بيانات Postgresql، وستتم قراءة البيانات مرة أخرى",
  Use_sqlite_data_will_store_in_local:"باستخدام sqlite، سيتم تخزين البيانات على الجهاز المحلي",
  UsePostgresqlDatabase:"باستخدام قاعدة بيانات PGSQL",
  UseSqliteDatabase:"باستخدام قاعدة بيانات Sqlite",
  DatabaseName:"قاعدة بيانات الاسم",
  Test_connect:"اختبار الاتصال",
  If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"إذا كان المنتج له لون أو مقاس يرجى ملء 0 للمخزون الأولي، بعد إضافة المنتج أدخل المخزون في الشراء.",
  my:"مِلكِي",
  my_shop_qrcode_scan:"يوفر رمز QR الخاص بمتجري للعملاء إمكانية مسح الرمز ضوئيًا لتقديم الطلبات، ويجب أن يكون الهاتف المحمول الخاص بالعميل متصلاً بنفس جهاز التوجيه المتصل بالكمبيوتر الخاص بك.",
  ip:"الملكية الفكرية",
  port:"ميناء",
  orderstatus:"حالة الطلب",
  image:"صورة",
  Template:"نموذج",
  Please_select_a_excel_file:"اختر ملفا، رجاءا",
  Please_select_only_one_excel_file:"يمكن تحديد ملف واحد فقط",
  Connect_Internet_Login_again:"اتصل بالإنترنت وقم بتسجيل الدخول مرة أخرى قبل الشراء",
  Please_Purchase_In_APP:'Please purchase in APP',
    productHasValidDate:'المنتج لديه فترة صالحة',
    productHasColor:'المنتج لديه حجم اللون',
    GeneralGoods:'البضائع العامة',
    Selected:'مختار',
    RestorePurchase:'استئناف الشراء',
    Buy_ElinkInvoice_Enterprise_Edition_OneUser:'اشترِ فاتورة Enterprise Edition 1 للمستخدمين بشكل دائم',
    Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'شراء الفواتير Enterprise Edition غير محدود للمستخدمين والأجهزة',
    Purchasing:'شراء ... يرجى الانتظار بصبر ...',
    Validdate:'فترة الصلاحية',
    Makedate:'تاريخ الإنتاج',
    Batch:'دفعة',
    CheckVersion:'تحقق الإصدار',
    Please_set_this_ip_address_on_App:'يرجى تعيين عنوان IP أو عنوان IP الخاص بجهاز الكمبيوتر على التطبيق.',
    Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'افتح هذا الاتصال في جهاز الكمبيوتر أو متصفح الهاتف المحمول (قم بتوصيل نفس شبكة WiFi)',
CheckVersion: 'التحقق من الإصدار',
You_need_to_purchase: 'لم تشتري بعد, يرجى إضافة WeChat إلى Elink9988 البريد الإلكتروني: bvbuy@qq.com ',
Thank_for_your_purchase: 'لقد اشتريت بالفعل',
New_version_available: 'هناك نسخة جديدة',
Is_the_latest_version: 'هو أحدث إصدار',
please:'رجاء',
input:'إدخال',
wrong:'خطأ',
Verifycode:'التحقق من كود',
Upload:'رفع',
Download:'تحميل',
You_need_to_purchase_to_continue_use:'تحتاج إلى شراء لمواصلة الاستخدام',
CheckBuy:'تحقق شراء',
Exists:'موجود',
NetworkUnavailable:'الشبكة غير متوفرة',
Today:'اليوم',
Yesterday:'في الامس',
ThisMonth:'هذا الشهر',
LastMonth:'LastMonth',
nickname:'كنية',
storeName:'اسم المتجر',
BuyStandAlone:'شراء نسخة قائمة بذاتها',
PermissionDenied:'طلب الاذن مرفوض',
    Boss:'Boss',
    login:'تسجيل الدخول',
    operate:'العمل',
    register:'تسجيل',
    username:'اسم المستخدم',
    password:'كلمه السر',
    User:'المستعمل',
    ok:'حسنا',
    back:'الى الخلف',
    success:'نجاح',
    fail:'فشل',
    cancel:'إلغاء',
    add:'إضافة',
    edit:'تصحيح',
    delete:'حذف',
    refresh:'تحديث',
    close:'قريب',
    cancel:'إلغاء',
    return:'إرجاع',
    ElinkInvoice:'إلين الفاتورة',
    Purchase:'شراء',
    BaseData:'البيانات الأساسية',
    Sell:'يبيع',
    PurchaseReturns:'عوائد الشراء',
    SellReturns:'بيع العوائد',
    Inventory:'المخزون',
    Statistics:'الإحصاء',
    Receivable:'ذمم مدينة',
    Payable:'تدفع',
    Orders:'أوامر',
    StockTransfer:'تحويل المخزن',
    StockRecall:'استدعاء الأسهم',
    Customer:'زبون',
    Supplier:'المورد',
    Warehouse:'مستودع',
    Color:'اللون',
    Size:'بحجم',
    Category:'الفئة',
    Category2:'فئة2',
    Product:'المنتج',
    Account:'الحساب',
    AccountType:'فئة الحساب',
    Staff:'العاملين',
    typeone:'الفئة',
    typetwo:'التصنيف الفرعي',
    ProductName:'اسم المنتج',
    Specification:'تخصيص',
    Barcode:'الباركود',
    Buyprice:'سعر شراء',
    Sellprice:'سعر البيع',
    Wholesaleprice:'سعر بالجملة',
    Currentstock:'التيارات توك',
    Unit:'وحدة',
    Initstock:'الأسهم الأولية',
    Parameter:'معامل',
    Remark:'تعليق',
    Supplier:'المورد',
    Customer:'زبون',
    Staff:'العاملين',
    Receivable:'ذمم مدينة',
    payable:'تدفع',
    Receipts:'المبالغ المستلمة',
    Paid:'دفع',
    Preferential:'تفضيلي',
    DateDay:'تاريخ',
    OrderNum:'رقم الطلب',
    Name:'اسم',
    UserName:'اسم المستخدم',
    IdNum:'رقم الهوية',
    BirthDay:'عيد الميلاد',
    SEX:'جنس',
    Female:'إناثا',
    Male:'الذكر',
    Select:'تحديد',
    Address:'عنوان',
    Phone:'هاتف',
    Email:'البريد الإلكتروني',
    CardNum:'رقم البطاقة',
    Price:'السعر',
    QTY:'الكمية',
    SupplierCategory:'فئة المورد',
    CustomerCategory:'فئة العملاء',
    Power:'قوة',
    Role:'وظيفة',
    save:'حفظ',
    image:'صورة',
    search:'بحث',
    Year:'عام',
    Month:'شهر',
    Day:'يوم',
    Total:'مجموع',
    WorkReport:'تقرير عمل',
    Leave:'غادر',
    CheckIn:'تحقق في',
    Announcement:'إعلان',
    Approval:'موافقة',
    Tracking:'تتبع',
    Bill:'مشروع قانون',
    OrdersDetail:'أوامر التفاصيل',
    Expense:'مصروف',
    Income:'الإيرادات',
    Userfor:'Userfor',
    Amount:'كمية',
    Title:'عنوان',
    News:'أخبار',
    SelectFile:'SelectFile',
    Content:'يحتوى',
    Cost:'كلفة',
    ApprovalUser:'موافقة المستخدم',
    ApprovalStatus:'حالة القبول',
    ApprovalRemark:'ملاحظة الموافقة',
    ApprovalDate:'تاريخ الموافقة',
    SubmitDate:'تاريخ النشر',
    Status:'الحالة',
    FromDateTime:'من تاريخ الوقت',
    ToDateTime:'لتاريخ الوقت',
    Subject:'موضوع',
    Latitude:'خط العرض',
    Longitude:'خط الطول',
    Print:'طباعة',
    DataTrans:'DataTrans',
    OA:'OA',
    Setting:'ضبط',
    Help:'مساعدة',
    ScanOpenInPhone:'مسح فتح في الهاتف',
    Building:'بناء',
    Room:'مجال',
    HotelCheckIn:'تحقق في',
    CheckOut:'الدفع',
    Hotel:'الفندق',
    Checkintime:'تحقق في الوقت المناسب',
    Checkouttime:'تحقق من الوقت',
    Deposit:'الوديعة',
    Cost:'كلفة',
    RoomNum:'الغرفة رقم',
    Rent:'تأجير',
    costday:'costday',
    rent:'تأجير',
    waternum:'درجة الماء',
    electricnum:'درجة الكهربائية',
    gasnum:'درجة الغاز',
    watercost:'تكلفة المياه',
    electriccost:'تكلفة الكهربائية',
    gascost:'تكلفة الغاز',
    cleaningcost:'تكلفة التنظيف',
    networkcost:'تكلفة الشبكة',
    tvcost:'تكلفة التلفزيون',
    managecost:'إدارة التكلفة',
    othercost:'تكلفة أخرى',
    totalcost:'التكلفة الإجمالية',
    remark:'تعليق',
    addtime:'إضافة وقت',
    OpenInBrowser:'افتح في المتصفح',
    InventoryProfit:'ربح المخزون',
    InventoryLoss:'خسارة المخزون',
    Buy:'يشترى',



Refresh:'تحديث',
Add:'إضافة',
Search:'بحث',
Records:'سجلات',
}



// WEBPACK FOOTER //
// ./src/lang/ar.js